import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';

export const Container = styled.div`
	max-width: 320px;
	min-width: 310px;
	width: 100%;
	height: auto;
	padding: 20px;
	background: #f5f7fa;
	border-radius: 6px;
	position: relative;
`;

export const CardItem = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	width: 100%;
`;

export const ItemCategory = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	margin-bottom: 20px;
`;
export const ItemDomain = styled.div<{ last?: boolean; first?: boolean }>`
	display: grid;
	grid-template-columns: 1fr 86px;
	padding: ${({ first }) => (first ? '0 0 20px 0' : '20px 0')};
	${({ last }) =>
		!last &&
		css`
			border-bottom: 1px solid #e6e6e6;
		`};
`;

export const ProgressContainer = styled.div`
	position: absolute;
	background: #f5f7fa;
	top: -30px;
	left: 250px;
	border-radius: 50%;
`;

export const ItemTitle = styled.p<{ domain?: boolean }>`
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: ${tokens.color_primary};
	margin-bottom: 14px;
	position: relative;

	${({ domain }) =>
		domain &&
		css`
			&::after {
				content: '';
				display: inline-block;
				height: 0.5em;
				vertical-align: bottom;
				width: 75%;
				margin-right: -100%;
				margin-left: 10px;
				border-bottom: 1px solid #d8dee6;
			}
		`}
`;

export const ItemDescription = styled.p<{
	variant?: boolean;
}>`
	font-weight: ${({ variant }) => (variant ? 700 : 600)};
	font-size: ${({ variant }) => (variant ? '18px' : '16px')};
	line-height: ${({ variant }) => (variant ? '28px' : '22px')};
	color: #64778f;
`;
